import React, { useState } from 'react';
import { Toggle } from '../ui/Toggle';
export function DisbursementTab() {
  const [disbursementEnabled, setDisbursementEnabled] = useState(true);
  return <div className="space-y-6 max-w-2xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-598">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-599">
        <h3 className="text-lg font-semibold text-gray-900 mb-6 pb-2 border-b border-gray-100" data-id="element-600">
          Disbursement Configuration
        </h3>

        <div className="space-y-4" data-id="element-601">
          <Toggle label="Disbursement Mode" checked={disbursementEnabled} onChange={setDisbursementEnabled} data-id="element-602" />

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-603">
            <div className="space-y-3" data-id="element-604">
              <div className="flex items-start" data-id="element-605">
                <div className="flex-shrink-0 w-20" data-id="element-606">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-607">
                    Enabled
                  </span>
                </div>
                <div className="ml-3" data-id="element-608">
                  <p className="text-sm text-gray-700" data-id="element-609">
                    <span className="font-medium" data-id="element-610">
                      Disbursement = Loan Amount – Fees
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-611">
                    Fees are deducted from the loan amount before disbursement
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-612">
                <div className="flex-shrink-0 w-20" data-id="element-613">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-614">
                    Disabled
                  </span>
                </div>
                <div className="ml-3" data-id="element-615">
                  <p className="text-sm text-gray-700" data-id="element-616">
                    <span className="font-medium" data-id="element-617">
                      Fees embedded in schedule
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-618">
                    Full loan amount is disbursed; fees are included in the
                    repayment schedule
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}